export enum TerminologyType {
  None = 0,
  Commission = 1,
  FiscalId = 2,
  Treatment = 3,
  Certification = 4
}